import * as React from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";
import styles from "./tabs.module.scss";

interface TabsProps extends React.ComponentPropsWithoutRef<typeof TabsPrimitive.Root> {}

function Tabs({ className, ...props }: TabsProps) {
  return <TabsPrimitive.Root className={className} {...props} />;
}

interface TabsListProps extends React.ComponentPropsWithoutRef<typeof TabsPrimitive.List> {}

function TabsList({ className, ...props }: TabsListProps) {
  return (
    <div className={`${styles.tabsWrap}${className ? ` ${className}` : ""}`}>
      <TabsPrimitive.List className={styles.tabs} {...props} />
    </div>
  );
}

interface TabsTriggerProps extends React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger> {}

function TabsTrigger({ className, ...props }: TabsTriggerProps) {
  return (
    <TabsPrimitive.Trigger className={`${styles.tabsItem}${className ? ` ${className}` : ""}`} {...props} />
  );
}

interface TabsContentProps extends React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content> {}

function TabsContent({ className, ...props }: TabsContentProps) {
  return (
    <TabsPrimitive.Content className={`${styles.tabsContent}${className ? ` ${className}` : ""}`} {...props} />
  );
}

export { Tabs, TabsList, TabsTrigger, TabsContent };
